let routes = [
  {
    path: '/',
    name: '付费阅读',
    component: () => import('../components/child_router_view'),
    children: [{
      path: '/reader-list',
      name: '阅读列表',
      component: () => import('../components/reader/list.vue')
    },
    {
      path: '/reader-section',
      name: '栏目管理',
      component: () => import('../components/reader/section.vue')
    },
    {
      path: '/reader-setting',
      name: '付费设置',
      component: () => import('../components/reader/setting.vue')
    },
    {
      path: '/add-article',
      name: '新建文章',
      component: () => import('../components/reader/new_article.vue')
    },
    {
      path: '/add-video',
      name: '新建视频',
      component: () => import('../components/reader/new_video_article.vue')
    },
    {
      path: '/author',
      name: '作者管理',
      component: () => import('../components/reader/author.vue')
    },
    {
      path: '/right-list',
      name: '权益管理',
      component: () => import('../components/reader/right_list.vue')
    },
    {
      path: '/caopan',
      name: '操盘直播',
      component: () => import('../components/reader/caopan/manager.vue'),
      children: [
        {
          path: '/caopan-list',
          name: '发表模式',
          component: () => import('../components/reader/caopan/list.vue')
        },{
          path: '/caopan-msg',
          name: '消息回复',
          component: () => import('../components/reader/caopan/message.vue')
        },
        {
          path: '/caopan-comment',
          name: '评论管理',
          component: () => import('../components/reader/comment.vue')
        }]
    },
    {
      path: '/comment',
      name: '评论管理',
      component: () => import('../components/reader/comment.vue')
    },
    {
      path: '/reader-order',
      name: '阅读单篇订单',
      component: () => import('../components/reader/order.vue')
    },
    {
      path: '/reader-order-month',
      name: '会员包月订单',
      component: () => import('../components/reader/order-month.vue')
    },
    {
      path: '/reader-sta-order',
      name: '阅读订单统计',
      component: () => import('../components/reader/sta-order.vue')
    },
    {
      path: '/reader-sta-order-month',
      name: '会员订购统计',
      component: () => import('../components/reader/sta-order-month.vue')
    },
    {
      path: '/reader-sta-article',
      name: '阅读量价订单统计',
      component: () => import('../components/reader/sta_article.vue')
    },
    {
      path: '/reader-sta-author',
      name: '作者收入统计',
      component: () => import('../components/reader/sta_author.vue')
    }],
    meta: {}
  }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/reader.js